import { EmpathyXConfig, GridItem, SearchState } from '../../../../models';
import { GETTERS_KEYS } from '../../../store.const';
import { GetterContext, RootStoreState } from '../../../store.interfaces';
import { SearchGetterContext } from '../../search.interfaces';
import { GridItemsReducer } from './grid-items-reducer.interfaces';

export class BannersReducer implements GridItemsReducer {
  reduce(gridItems: GridItem[], context: SearchGetterContext): GridItem[] {
    const { banners }: EmpathyXConfig = context.rootGetters[GETTERS_KEYS.config.config];
    if (banners.position === 'first') {
      return this.addBannersFirst(gridItems, context);
    } else if (banners.position === 'every-nth-row') {
      return this.addBannersEveryNthRow(gridItems, context);
    }
    return gridItems;
  }

  private addBannersFirst(gridItems: GridItem[], { state: { banners } }: GetterContext<SearchState, RootStoreState>): GridItem[] {
    return (banners as GridItem[]).concat(gridItems);
  }

  private addBannersEveryNthRow(gridItems: GridItem[], { state, rootGetters }: GetterContext<SearchState, RootStoreState>): GridItem[] {
    const { banners: { rowFrequency }, resultsGrid: { grid: gridConfig } }: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];
    state.banners.forEach((banner, index) => {
      const targetIndex = (index + 1) * gridConfig.columns * (rowFrequency - 1);
      gridItems.splice(targetIndex, 0, banner);
    });
    return gridItems;
  }
}
